import React from "react";
type SVGLineChartProps = { className?: string };
const SVGLineChart: React.FC<SVGLineChartProps> = (props) => (
	<svg
		width="12"
		height="12"
		viewBox="0 0 12 12"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={props?.className}
	>
		<path
			d="M11.25 11.25H1.68333C1.35664 11.25 1.19329 11.25 1.06851 11.1864C0.958744 11.1305 0.869506 11.0413 0.81358 10.9315C0.75 10.8067 0.75 10.6434 0.75 10.3167V0.75M10.6667 3.66667L8.38066 6.10655C8.29402 6.19902 8.25071 6.24525 8.19845 6.26915C8.15232 6.29024 8.10149 6.29894 8.05098 6.29439C7.99375 6.28923 7.93752 6.26003 7.82506 6.20164L5.92494 5.21502C5.81248 5.15663 5.75625 5.12744 5.69902 5.12228C5.64851 5.11773 5.59768 5.12643 5.55155 5.14752C5.49929 5.17142 5.45598 5.21765 5.36934 5.31012L3.08333 7.75"
			stroke="currentColor"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export default SVGLineChart;
